/**
 * mcpbVideoInfoPref — persists the cog "Camera Info overlay" toggle, mirroring util/theme.js +
 * util/camTheme.js (a localStorage display preference: available pre-mount, surviving logout).
 *
 * Unlike camTheme it sets no DOM attribute — the value is read into React state by MCPlaybackView and
 * threaded down to the cells (it only has an effect inside MCPlayback). Global per browser, like
 * mcpbAutoSkip / appTheme — NOT per {serial,user}. Default OFF: the diagnostic overlay is opt-in,
 * matching the desktop DstreamView "Toggle Info" default (drawFPS = false). (plan §15 Q16:
 * toggle-camera-info is persisted.)
 */
const VIDEO_INFO_KEY = 'mcpbVideoInfo';

export const getVideoInfoPref = () => {
  try { return localStorage.getItem(VIDEO_INFO_KEY) === '1'; } catch (e) { return false; }
};

export const setVideoInfoPref = (enabled) => {
  const next = !!enabled;
  try { localStorage.setItem(VIDEO_INFO_KEY, next ? '1' : '0'); } catch (e) { /* ignore */ }
  return next;
};
